import React, { Component } from "react";
import { Div, Img, H1, P, Button, Input, Span } from "glamorous";
import Hammer from "hammerjs";
import icons from "../../../imgs/icons";
import styles from "../../../styles";
import data from "../../../data/index";
import { touchsupport } from "../../../misc/utils";
import { cropActions } from "./actions";

const hideIcon = () => state => {
  state.iconHidden = true;
  return state;
};

class CropPhoto extends Component {
  constructor(props) {
    super(props);
    this.state = {
      warning: null,
      iconHidden: false
    };
    this.prevState = {
      pos: {
        x: this.props.images.crop.x,
        y: this.props.images.crop.y
      },
      scale: this.props.images.crop.scale
    };

    this.hammerAdded = false;
    this.touchsupport = touchsupport();
    this.imageRef = null;
  }

  render() {
    return (
      <Div
        onTouchStart={() => {
          this.setState(hideIcon());
        }}
        onTouchEnd={evt => {
          if (evt.currentTarget.tagName !== "BUTTON") {
            this.setState(
              cropActions.checkImage({ ...this.refs, imageRef: this.imageRef })
            );
          }
        }}
        onMouseUp={evt => {
          if (evt.currentTarget.tagName !== "BUTTON") {
            this.setState(
              cropActions.checkImage({ ...this.refs, imageRef: this.imageRef })
            );
          }
        }}
        className="container"
      >
        <H1 css={styles.editor.title}>{data.copy("cropHeading")}</H1>
        <Div css={styles.editor.columnWrapper}>
          <Div css={styles.crop.leftCol}>
            <Div css={styles.crop.cropAreaWrapper}>
              <Div
                innerRef={el => {
                  if (!this.hammerAdded) {
                    this.addHammerEvents(el);
                  }
                }}
                onTouchStart={evt => this.setState(cropActions.clearWarning())}
                onMouseDown={evt => this.setState(cropActions.clearWarning())}
                css={styles.crop.cropArea(this.props.method)}
              >
                <Div css={styles.crop.previewBoxWrapper}>
                  <div ref="cropWindow" style={styles.crop.previewBox}>
                    <Img
                      onDragStart={evt => evt.preventDefault()}
                      src={icons.cutLine}
                      css={styles.editor.cutLineLeft}
                    />
                    <Img
                      onDragStart={evt => evt.preventDefault()}
                      src={icons.cutLine}
                      css={styles.editor.cutLineRight}
                    />
                    <Img
                      onDragStart={evt => evt.preventDefault()}
                      src={this.props.border}
                      css={styles.editor.previewImage}
                    />
                  </div>
                </Div>
                <Img
                  src={this.props.images.origin.src}
                  style={{
                    transform: `translate(${this.props.images.crop.x ||
                      0}px, ${this.props.images.crop.y || 0}px) scale(${this
                      .props.images.crop.scale || 1})`
                  }}
                  css={styles.crop.image(this.props.method)}
                  onDragStart={evt => evt.preventDefault()}
                  onLoad={evt => {
                    if (!this.imageRef) {
                      const el = evt.currentTarget;
                      this.imageRef = el;
                      this.setState(
                        cropActions.checkImage({
                          ...this.refs,
                          imageRef: this.imageRef
                        })
                      );
                    }
                  }}
                />
                {!this.touchsupport && (
                  <Span css={styles.crop.cursor} />
                )}
              </Div>
            </Div>
            {this.touchsupport && !this.state.iconHidden && (
              <Img src={icons.pinchIcon} css={styles.crop.pinchIcon} />
            )}
            {!this.touchsupport && (
              <P css={styles.crop.desktopInstruction}>
                {data.copy("clickDrag")}
                <Img src={icons.cursor} />
              </P>
            )}
          </Div>
          <Div css={styles.editor.rightCol}>
            <Div css={styles.crop.sliderWrapper}>
              <Input
                type="range"
                min="0.1"
                max="10"
                step="0.1"
                defaultValue="1"
                css={styles.editor.slider}
                onMouseDown={evt => this.setState(cropActions.clearWarning())}
                onChange={evt => this.props.handleCropSlide({ ...evt })}
              />
            </Div>
            <Div css={styles.crop.actionWrapper}>
              {this.state.warning && (
                <Div css={styles.crop.warning(this.props.method)}>
                  <P css={styles.crop.warningTitle}>
                    {this.state.warning.title || ""}
                  </P>
                  <P css={styles.crop.warningDescription || ""}>
                    {this.state.warning.description}
                  </P>
                </Div>
              )}
              <Div
                css={{
                  ...styles.crop.ctas(this.props.method),
                  marginTop: this.state.warning ? "2vh" : "50vh"
                }}
              >
                <Button
                  css={styles.ctas.outline}
                  onClick={() => {
                    this.props.setArea("Landing");
                  }}
                >
                  {data.copy("changePhotoBtn")}
                </Button>
                <Button
                  css={styles.ctas.initial}
                  onClick={() => this.crop("EditorSimple")}
                >
                  {data.copy("happyPhotoBtn")}
                </Button>
              </Div>
            </Div>
          </Div>
        </Div>
      </Div>
    );
  }

  async crop(nextArea) {
    const src = await cropActions.generateImage({
      ...this.refs,
      imageRef: this.imageRef
    });
    this.props.setImage("crop", {
      src,
      x: this.props.images.crop.x,
      y: this.props.images.crop.y,
      scale: this.props.images.crop.scale
    });
    this.props.onImageUpload(src);
  }

  addHammerEvents(el) {
    const recognizers = [[Hammer.Pan]];

    if (this.touchsupport) {
      recognizers.push([Hammer.Pinch, { enable: true }]);
    }

    const hammertime = new Hammer(el, {
      recognizers: recognizers
    });

    hammertime.on("panmove", evt =>
      this.props.handleCropPanMove(evt, this.prevState.pos)
    );

    hammertime.on(
      "panend",
      () =>
        (this.prevState = this.props.handleCropPanEnd(this.prevState, {
          x: this.props.images.crop.x,
          y: this.props.images.crop.y
        }))
    );

    hammertime.on("pinchmove", evt =>
      this.props.handleCropPinchMove(evt, this.prevState.scale)
    );

    hammertime.on(
      "pinchend",
      () =>
        (this.prevState = this.props.handleCropPinchEnd(
          this.prevState,
          this.props.images.crop.scale
        ))
    );

    this.hammerAdded = true;
  }
}

export default CropPhoto;



// WEBPACK FOOTER //
// ./src/components/areas/CropPhoto/index.js